module.exports = __webpack_public_path__ + "static/screen2-8ffe70588f9a23b7d94658288450f65d.png";